<div class="container-fluid">
  <div class="fw-bold fs-27">
    User Access
    <div class="border-green-bottom"></div>
  </div>

  <div class="d-flex gap-4 border-bottom border-secondary mt-3 mb-3">
    <div
      class="tab-item fs-14 fw-bold font-white pb-2 position-relative"
      [class.active]="selectedTab === 'Permission'"
      (click)="onTabChange('Permission')"
      tabindex="0"
      (keydown.enter)="onTabChange('Permission')">
      <div class="px-3">Permission</div>
      <div class="tab-underline position-absolute start-0 bottom-0 w-100"></div>
    </div>
    <div class="tab-item fs-14 fw-bold font-white pb-2 position-relative" [class.active]="selectedTab === 'Users'" (click)="onTabChange('Users')" tabindex="0" (keydown.enter)="onTabChange('Users')">
      <div class="px-3">Users</div>
      <div class="tab-underline position-absolute start-0 bottom-0 w-100"></div>
    </div>
  </div>

  <div *ngIf="selectedTab === 'Permission'">
    <div class="d-flex justify-content-end align-items-center mb-3">
      <div class="search-area">
        <div [innerHtml]="SVG_ICONS.SEARCH_ICON() | sanitizer : 'html'" class="search-icon"></div>
        <input type="text" class="search-input" placeholder="Search User Roles..." (keyup)="applyPermissionFilter($event)" />
      </div>
      <!-- <button class="btn btn-success" (click)="addNewRole()">Create New Role</button> -->
    </div>
    <div class="roles-container gap-3 flex-column d-flex">
      @for (userType of filteredList; track userType.UserTypeID) {
      <div class="role-item">
        <div class="role-header" (click)="toggleRoleExpansion(userType)" tabindex="0" (keydown.enter)="toggleRoleExpansion(userType)">
          <span class="fw-bold fs-16 font-white">{{ userType.UserType || "New User Role" }}</span>
          <div class="actions">
            <span class="expander" [@indicatorRotate]="expandedUserTypeId === (userType.isNew ? 'new' : userType.UserTypeID) ? 'expanded' : 'collapsed'">
              <div [innerHTML]="SVG_ICONS.RIGHT_ARROW() | sanitizer : 'html'"></div>
            </span>
          </div>
        </div>
        @if (expandedUserTypeId === (userType.isNew ? 'new' : userType.UserTypeID)) {
        <div class="role-editor-content">
          @if (userType.isLoading) {
          <div class="loading-state">Loading Permissions...</div>
          } @else {
          <div class="permission-tree border-radius-5 font-white bg-gray">
            <div class="menu-row header-row fw-bold fs-12 font-gray border-bottom">
              <div class="menu-name">Module Name</div>
              <div class="menu-perms d-flex justify-content-evenly align-items-center">
                <label class="custom-checkbox">
                  <input type="checkbox" (change)="updateAllPermissions($event, 'canAdd', userType.MasterMenuList || [])" />
                  <span class="checkmark"></span>
                </label>
                <span class="me-1">Create</span>
                <label class="custom-checkbox">
                  <input type="checkbox" (change)="updateAllPermissions($event, 'canEdit', userType.MasterMenuList || [])" />
                  <span class="checkmark"></span>
                </label>
                <span class="me-1">Update</span>
                <label class="custom-checkbox">
                  <input type="checkbox" (change)="updateAllPermissions($event, 'canDelete', userType.MasterMenuList || [])" />
                  <span class="checkmark"></span>
                </label>
                <span class="me-1">Delete</span>
              </div>
            </div>
            <!-- <div class="header-checkboxes">
              <div class="menu-name"></div>
              <div>Select All</div>

              <div class="menu-perms d-flex justify-content-evenly">
                <label class="custom-checkbox">
                  <input type="checkbox" (change)="updateAllPermissions($event, 'canAdd', userType.MasterMenuList || [])" />
                  <span class="checkmark"></span>
                </label>
                <label class="custom-checkbox">
                  <input type="checkbox" (change)="updateAllPermissions($event, 'canEdit', userType.MasterMenuList || [])" />
                  <span class="checkmark"></span>
                </label>
                <label class="custom-checkbox">
                  <input type="checkbox" (change)="updateAllPermissions($event, 'canDelete', userType.MasterMenuList || [])" />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div> -->
            <div class="menu-body">
              @for (item of userType.MasterMenuList; track item.MenuID) {
              <ng-container [ngTemplateOutlet]="MenuItemTemplate" [ngTemplateOutletContext]="{ item: item }"></ng-container>
              }
            </div>
          </div>

          <div class="d-flex justify-content-end mt-5">
            <button class="close-btn me-2 px-4 py-1" (click)="onCancel()">Close</button>
            <button class="add-btn px-4 py-1" (click)="onSubmit(userType)">
              {{
                userType.isNew
                  ? "Save Role"
                  : "Update
              Role"
              }}
            </button>
          </div>
          <!-- <div class="editor-actions  gap-2">
            <button class="btn btn-danger" (click)="onCancel()">
              Cancel
            </button>
            <button class="btn btn-success" (click)="onSubmit(userType)">
              {{ userType.isNew ? "Save Role" : "Update Role" }}
            </button>
          </div> -->
          }
        </div>
        }
      </div>
      } @empty {
      <div class="no-results">No user roles found.</div>
      }
    </div>
  </div>

  <div *ngIf="selectedTab === 'Users'">
    <div class="d-flex justify-content-end mb-3">
      <div class="search-area">
        <div [innerHTML]="SVG_ICONS.SEARCH_ICON() | sanitizer : 'html'" class="search-icon"></div>
        <input type="text" class="search-input" placeholder="Search Users..." (keyup)="applyUserFilter($event)" />
      </div>
    </div>

    <div class="mat-elevation-z2 bg-gray border-radius-10 overflow-auto">
      <table mat-table [dataSource]="dataSource" class="mat-table font-white w-100">
        <!-- USER COLUMN -->
        <ng-container matColumnDef="userInfo">
          <th mat-header-cell *matHeaderCellDef class="font-gray">User</th>
          <td mat-cell *matCellDef="let user">
            <div class="fw-bold font-white">{{ user.UserLoginID }}</div>
            <div class="fs-12 font-white">{{ user.UserEmail }}</div>
          </td>
        </ng-container>

        <!-- MOBILE COLUMN -->
        <ng-container matColumnDef="mobile">
          <th mat-header-cell *matHeaderCellDef class="font-gray">Mobile No</th>
          <td mat-cell *matCellDef="let user">
            <a href="tel:+91{{ user.UserMobile }}" class="font-white text-decoration-none"> +91 {{ user.UserMobile }} </a>
          </td>
        </ng-container>

        <!-- DYNAMIC ROLE COLUMNS -->
        <ng-container *ngFor="let role of userTypeList" [matColumnDef]="'role-' + role.UserTypeID">
          <th mat-header-cell *matHeaderCellDef class="font-gray">{{ role.UserType }}</th>
          <td mat-cell *matCellDef="let user">
            <label class="custom-checkbox">
              <input type="checkbox" [checked]="user.UserTypeIDs?.includes(role.UserTypeID)" (change)="onRoleChange(user, role.UserTypeID, $event)" [disabled]="user.isUpdating" />
              <span class="checkmark"></span>
            </label>
          </td>
        </ng-container>

        <!-- ACTION COLUMN -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="font-gray">Action</th>
          <td mat-cell *matCellDef="let user">
            <div class="d-flex gap-2">
              <button class="btn btn-sm btn-primary" (click)="updateUserRoles(user)" [disabled]="user.isUpdating || !hasRoleChanges(user)" title="Update Roles">
                <span *ngIf="!user.isUpdating">Update</span>
                <span *ngIf="user.isUpdating" class="spinner-border spinner-border-sm"></span>
              </button>
              <!-- for user wise permission  -->

              <!-- <button class="btn btn-sm btn-info" (click)="openPermissionsDialog(user)" [disabled]="user.isUpdating" title="View Rights">
                <div [innerHTML]="SVG_ICONS.USER_ACCESS() | sanitizer : 'html'" class="icon-14"></div>
              </button> -->
            </div>
          </td>
        </ng-container>

        <!-- TABLE HEADER + ROWS -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="Select page of users" class="mt-3"> </mat-paginator>
    </div>
  </div>
</div>

<ng-template #MenuItemTemplate let-item="item">
  <div class="menu-item-container">
    <div class="menu-row">
      <div class="menu-name">
        <div class="expander" (click)="toggleMenuItem(item)" [class.invisible]="!item.ChildList?.length">
          <div [innerHTML]="SVG_ICONS.DOWN_ARROW() | sanitizer : 'html'" [@indicatorRotate]="item.expanded ? 'expanded' : 'collapsed'"></div>
        </div>
        <span class="menu-text">{{ item.MenuName }}</span>
      </div>
      <div class="menu-perms d-flex justify-content-evenly">
        <label class="custom-checkbox me-5">
          <input type="checkbox" [(ngModel)]="item.canAdd" (change)="updatePermissionForFamily($event, 'canAdd', item)" />
          <span class="checkmark"></span>
        </label>
        <label class="custom-checkbox me-5">
          <input type="checkbox" [(ngModel)]="item.canEdit" (change)="updatePermissionForFamily($event, 'canEdit', item)" />
          <span class="checkmark"></span>
        </label>
        <label class="custom-checkbox me-5">
          <input type="checkbox" [(ngModel)]="item.canDelete" (change)="updatePermissionForFamily($event, 'canDelete', item)" />
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
  </div>
  @if (item.expanded && item.ChildList?.length) {
  <div class="child-container">
    @for (child of item.ChildList; track child.MenuID) {
    <ng-container [ngTemplateOutlet]="MenuItemTemplate" [ngTemplateOutletContext]="{ item: child }"></ng-container>
    }
  </div>
  }
</ng-template>
